<div class="container col-sm-12 col-md-6 offset-md-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <ng-container *ngIf="this.doctorreg.others.tabViewData.selected_tab==0">
        <div class="form-back  h4 my-4">
            <a [routerLink]="['/', this.slug]">&#8592; Back</a>
        </div>
        <div class="mb-2 pb-lg-2 pb-4">
            <div class="doc-reg-heading font-weight-bold text-center">
                <h2>
                    Doctor Registration
                </h2>
            </div>
            <div class="font-weight-bold text-center m-2">For guide on registration process<a
                    href="https://youtu.be/RXvWySbpVTc" target="_blank" class="egd-color ml-2"> Click here </a></div>
        </div>

        <form accept-charset="UTF-8" id="register_form" #doctorregistrationform="ngForm"
            (submit)="submitDoctorRegistration()">
            <div class="formdiv bg-light text-dark p-4">
                <div class="form-group row">
                    <label class="col-sm-12 mb-3 mb-lg-0 font-weight-bold ml-3" for="Name">Name*</label>
                    <div class="col-md-6 col-sm-12 mb-3 mb-lg-0">


                        <input type="text" class="form-control rounded-pill" id="firstname" name="firstname"
                            aria-describedby="Name" placeholder="First Name*" [pattern]="name_input"
                            [(ngModel)]="this.doctorreg.api_data.first_name" #first_name="ngModel"
                            [class.form-input-error]="(first_name?.invalid && (first_name?.dirty || first_name?.touched)) && (first_name.errors?.required)"
                            [class.form-input-success]="(!first_name?.invalid && (first_name?.dirty || first_name?.touched)) && !(first_name.errors?.required)"
                            required>
                        <div *ngIf="!this.doctorreg_boolean.first_name" class="col-sm-12 pl-2">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                First Name is required.
                            </div>
                        </div>
                        <div *ngIf="first_name?.invalid && (first_name?.dirty || first_name?.touched)"
                            class="col-sm-12 pl-2">
                            <div *ngIf="this.doctorreg_boolean.first_name && first_name.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                First Name is required.
                            </div>
                            <div *ngIf="first_name.errors?.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Invalid First Name.
                            </div>
                            <div *ngIf="first_name.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Only alphabets and spaces are allowed.
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input type="text" class="form-control rounded-pill" id="middlename" name="middlename"
                            aria-describedby="middlename" placeholder="Middle Name" [pattern]="name_input"
                            [(ngModel)]="this.doctorreg.api_data.middle_name" #middle_name="ngModel">
                        <div *ngIf="middle_name?.invalid && (middle_name?.dirty || middle_name?.touched)"
                            class="col-sm-12 pl-2">
                            <div *ngIf="middle_name.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Only alphabets and spaces are allowed.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-12 col-sm-12">
                        <input type="text" class="form-control rounded-pill" id="lastname" name="lastname"
                            aria-describedby="lastname" placeholder="Last Name*" [pattern]="name_input"
                            [(ngModel)]="this.doctorreg.api_data.last_name" #last_name="ngModel"
                            [class.form-input-error]="(last_name?.invalid && (last_name?.dirty || last_name?.touched)) && (last_name.errors?.required)"
                            [class.form-input-success]="(!last_name?.invalid && (last_name?.dirty || last_name?.touched)) && !(last_name.errors?.required)"
                            required>
                        <div *ngIf="!this.doctorreg_boolean.last_name" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Last Name is required.
                            </div>
                        </div>
                        <div *ngIf="last_name?.invalid && (last_name?.dirty || last_name?.touched)" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.last_name && last_name.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Last Name is required.
                            </div>
                            <div *ngIf="last_name.errors?.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Invalid Last Name.
                            </div>
                            <div *ngIf="last_name.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Only alphabets and spaces are allowed.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-12 font-weight-bold ml-3" for="email">Email*</label>
                    <div class="col-md-12 col-sm-12">

                        <input id="email" name="email" type="email" class="form-control rounded-pill"
                            aria-describedby="email" FieldValidator="email" placeholder="Enter your email"
                            [(ngModel)]="this.doctorreg.api_data.d_email" #email="ngModel"
                            [class.form-input-error]="(email?.invalid && (email?.dirty || email?.touched)) && (email?.errors?.required || email.errors?.FieldValidator )"
                            [class.form-input-success]="(!email?.invalid && (email?.dirty || email?.touched)) && !(email?.errors?.required || email.errors?.FieldValidator )"
                            required>
                        <!-- required> -->
                        <div *ngIf="!this.doctorreg_boolean.d_email" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Email is required.
                            </div>
                        </div>
                        <div *ngIf="(email?.invalid && (email?.dirty || email?.touched))" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.d_email && email.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Email is required.
                            </div>
                            <div *ngIf="email.errors?.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Invalid Email.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-12 font-weight-bold ml-3" for="password">Password*</label>
                    <div class="col-md-12 col-sm-12">

                        <div class="input-group">
                            <input id="password" name="password"
                                [type]="!this.doctorreg.others.passwordData.isPassword?'text':'password'"
                                class="form-control input-of-append-icon" aria-describedby="password"
                                placeholder="********" minlength="8" FieldValidator="password"
                                [(ngModel)]="this.doctorreg.api_data.d_password" #password="ngModel"
                                [class.form-input-error]="(password?.invalid && (password?.dirty || password?.touched)) && (password.errors?.required || password.errors?.minlength || password.errors?.FieldValidator)"
                                [class.form-input-success]="(!password?.invalid && (password?.dirty || password?.touched)) && !(password.errors?.required || password.errors?.minlength || password.errors?.FieldValidator)"
                                required>
                            <div class="input-group-append">
                                <span class="input-group-text icon-of-append-icon"
                                    [class.form-input-error]="(password?.invalid && (password?.dirty || password?.touched)) && (password.errors?.required || password.errors?.minlength || password.errors?.FieldValidator)"
                                    [class.form-input-success]="(!password?.invalid && (password?.dirty || password?.touched)) && !(password.errors?.required || password.errors?.minlength || password.errors?.FieldValidator)">
                                    <i toggle="#password-field" role="button"
                                        class="fa fa-question-circle fa-fw text-dark"
                                        (click)="this.doctorreg.others.passwordData.toggleTips()">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.d_password" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password is required.
                            </div>
                        </div>
                        <div *ngIf="(password?.invalid && (password?.dirty || password?.touched))" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.d_password && password.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password is required.
                            </div>
                            <div *ngIf="password.errors?.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Password should contain minimum 8 characters, at least 1 Uppercase, 1
                                Special Character and 1 number.
                            </div>
                            <div *ngIf="password.errors?.minlength" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Minimum length should be of 8 characters.
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <div *ngIf="this.doctorreg.others.passwordData.tipsPasswordShowed"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password should contain minimum 8 characters, at least 1 Uppercase, 1
                                Special Character and 1 number.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-12 font-weight-bold ml-3" for="password">Confirm Password*</label>
                    <div class="col-md-12 col-sm-12">

                        <div class="input-group">
                            <input id="confirmPassword" name="confirmPassword"
                                [type]="!this.doctorreg.others.passwordData.isPassword?'text':'password'"
                                class="form-control input-of-append-icon" aria-describedby="confirmPassword"
                                placeholder="********" minlength="8" FieldValidator="password"
                                [(ngModel)]="this.doctorreg.api_data.confirm_d_password" #confirmPassword="ngModel"
                                [class.form-input-error]="(confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) && (confirmPassword.errors?.required || confirmPassword.errors?.minlength || confirmPassword.errors?.FieldValidator)"
                                [class.form-input-success]="(!confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) && !(confirmPassword.errors?.required || confirmPassword.errors?.minlength || confirmPassword.errors?.FieldValidator)"
                                required>
                            <div class="input-group-append">
                                <span class="input-group-text icon-of-append-icon"
                                    [class.form-input-error]="(confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) && (confirmPassword.errors?.required || confirmPassword.errors?.minlength || confirmPassword.errors?.FieldValidator)"
                                    [class.form-input-success]="(!confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) && !(confirmPassword.errors?.required || confirmPassword.errors?.minlength || confirmPassword.errors?.FieldValidator)">
                                    <i toggle="#password-field" role="button" class="text-dark fa fa-fw"
                                        [ngClass]="{'fa-eye': this.doctorreg.others.passwordData.isPassword,'fa-eye-slash': !this.doctorreg.others.passwordData.isPassword}"
                                        (click)="this.doctorreg.others.passwordData.toggleType()"></i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.confirm_d_password" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Confirm Password is required.
                            </div>
                        </div>
                        <div *ngIf="(confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched))"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.confirm_d_password &&  confirmPassword.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Confirm Password is required.
                            </div>
                            <div *ngIf="confirmPassword.errors?.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Password should contain minimum 8 characters, at least 1 Uppercase, 1
                                Special Character and 1 number.
                            </div>
                            <div *ngIf="confirmPassword.errors?.minlength" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Minimum length should be of 8 characters.
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <div *ngIf="confirmPassword?.value!=password?.value"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password and Confirm Password do not match.
                            </div>
                        </div>

                    </div>
                </div>
                <div class="form-group row">

                    <div class="col-md-6 col-sm-12 mb-2">
                        <label class="col-sm-12 font-weight-bold" for="gender">Gender*</label>
                        <div class="col-md-12 col-sm-12">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input ml-md-0 ml-lg-0" type="radio" name="inlineRadioOptions"
                                    id="inlineRadio1" value="male" [(ngModel)]="this.doctorreg.api_data.gender"
                                    #gender="ngModel" required>
                                <label class="form-check-label" for="inlineRadio1">Male</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                                    value="female" [(ngModel)]="this.doctorreg.api_data.gender" #gender="ngModel"
                                    required>
                                <label class="form-check-label" for="inlineRadio2">Female</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3"
                                    value="other" [(ngModel)]="this.doctorreg.api_data.gender" #gender="ngModel"
                                    required>
                                <label class="form-check-label" for="inlineRadio3">Other</label>
                            </div>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.gender" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Gender is required.
                            </div>
                        </div>
                        <div *ngIf="gender?.invalid && (gender?.dirty || gender?.touched)" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.gender && gender.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Gender is required.
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <label class="col-sm-12 font-weight-bold" for="language">Languages Spoken*</label>
                        <p-multiSelect id="language" [filter]="true" name="language" placeholder="Select"
                            [options]="this.doctorreg.others_data.languages" styleClass="input-pill"
                            [(ngModel)]="this.doctorreg.api_data.language_id" #languages_spoken="ngModel"
                            [ngClass]="{'p-multiselect-error':(languages_spoken?.invalid && (languages_spoken?.dirty || languages_spoken?.touched)) && (languages_spoken.errors?.required), 
                            'p-multiselect-success' :(!languages_spoken?.invalid && (languages_spoken?.dirty || languages_spoken?.touched)) && !(languages_spoken.errors?.required)}" required>
                        </p-multiSelect>
                        <div *ngIf="!this.doctorreg_boolean.language_id" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Languages Spoken is required.
                            </div>
                        </div>
                        <div *ngIf="languages_spoken?.invalid && (languages_spoken?.dirty || languages_spoken?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.language_id && languages_spoken.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Languages Spoken is required.
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form-group row">
                    <div class="col-md-6 col-sm-12">
                        <label class="col-sm-12 font-weight-bold" for="country">Country*</label>
                        <p-dropdown id="dropdown" [options]="this.doctorreg.others_data.countries"
                            styleClass="input-pill input-dropdown-pill mb-3 pl-3"
                            [(ngModel)]="this.doctorreg.others.selected_country" (onChange)="onChangeCountry()"
                            [filter]="true" #country="ngModel" [filterBy]='"label"' placeholder="Select Country"
                            [ngClass]="{'p-dropdown-error':(country?.invalid && (country?.dirty || country?.touched)) && (country.errors?.required), 
                            'p-dropdown-success' :(!country?.invalid && (country?.dirty || country?.touched)) && !(country.errors?.required)}"
                            [required]="true">
                        </p-dropdown>
                        <div *ngIf="!this.doctorreg_boolean.country_id" class="col-sm-12 pl-2">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Country is required.
                            </div>
                        </div>
                        <div *ngIf="country?.invalid && (country?.dirty || country?.touched)" class="col-sm-12 pl-2">
                            <div *ngIf="this.doctorreg_boolean.country_id && country.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Country is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <label class="col-sm-12 font-weight-bold" for="state">State*</label>
                        <p-dropdown id="dropdown" [options]="this.doctorreg.others_data.states"
                            styleClass="input-pill input-dropdown-pill mb-3 pl-3"
                            [(ngModel)]="this.doctorreg.others.selected_state" #state="ngModel" [filter]="true"
                            [filterBy]='"label"' placeholder="Select State"
                            [ngClass]="{'p-dropdown-error':(state?.invalid && (state?.dirty || state?.touched)) && (state.errors?.required), 
                            'p-dropdown-success' :(!state?.invalid && (state?.dirty || state?.touched)) && !(state.errors?.required)}" [required]="true">
                        </p-dropdown>

                        <div *ngIf="!this.doctorreg_boolean.state_name" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                State is required.
                            </div>
                        </div>
                        <div *ngIf="state?.invalid && (state?.dirty || state?.touched)" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.state_name && state.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                State is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-6">
                        <label class="col-sm-12 font-weight-bold" for="primaryno">Primary Mobile No.*</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text prepend-of-append-prepend"
                                    [class.form-input-error]="(primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)) && (primary_no.errors?.required || primary_no.errors?.maxlength || primary_no.errors?.pattern)"
                                    [class.form-input-success]="(!primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)) && !(primary_no.errors?.required || primary_no.errors?.maxlength || primary_no.errors?.pattern)">
                                    {{this.doctorreg.others.phone_code}}
                                </span>
                            </div>
                            <input type="text" class="form-control input-of-append-prepend" id="primaryno"
                                name="primaryno" aria-describedby="primaryno" [pattern]="phoneNumber" maxlength="20"
                                [(ngModel)]="this.doctorreg.others.primary_number" placeholder="Primary Number"
                                #primary_no="ngModel"
                                [class.form-input-error]="(primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)) && (primary_no.errors?.required || primary_no.errors?.maxlength || primary_no.errors?.pattern)"
                                [class.form-input-success]="(!primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)) && !(primary_no.errors?.required || primary_no.errors?.maxlength || primary_no.errors?.pattern)"
                                required>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.primary_contact_number" class="col-sm-12 pl-2">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Primary Phone No. is required.
                            </div>
                        </div>
                        <div *ngIf="primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)"
                            class="col-sm-12 pl-2">
                            <div *ngIf="this.doctorreg_boolean.primary_contact_number && primary_no.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Primary Phone No. is required.
                            </div>
                            <!-- <div *ngIf="primary_no.errors?.maxlength" class="col-sm-12 alert alert-danger m-2"
                              role="alert">
                              Phone number should be of 10 digits.
                          </div> -->
                            <div *ngIf="primary_no.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Only Numbers are allowed.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <label class="col-sm-12 font-weight-bold" for="date">Date of Birth*</label>
                        <p-calendar id="dob" name="dob" class="notranslate" [defaultDate]="max_date"
                            [maxDate]="max_date" id="dob" FieldValidator="Dob" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%','border-radius':'50rem'}"
                            placeholder="Date of Birth (MM/DD/YYYY)" dateFormat="dd/mm/yy"
                            [(ngModel)]="this.doctorreg.api_data.date_of_birth_date" [monthNavigator]="true"
                            [yearNavigator]="true" yearRange="1900:2099" [showIcon]="false" placeholder="dd/mm/yyyy"
                            #date_of_birth="ngModel"
                            [ngClass]="{'p-calendar-success':(!date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)) && !(date_of_birth.errors?.required &&  date_of_birth.errors?.FieldValidator), 'p-calendar-error' :(date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)) && (date_of_birth.errors?.required ||  date_of_birth.errors?.FieldValidator)}"
                            [required]="true">
                        </p-calendar>
                        <div *ngIf="!this.doctorreg_boolean.date_of_birth" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Date of Birth is required.
                            </div>
                        </div>
                        <div *ngIf="date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.date_of_birth && date_of_birth.errors.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Date of Birth is required.
                            </div>
                            <div *ngIf="date_of_birth.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Invalid Date Of Birth. User must be at least 18.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold ml-1" for="salutation">Salutation*</label>
                        <select name="salutation" class="custom-select custom-select mb-3 rounded-pill"
                            [(ngModel)]="this.doctorreg.api_data.salutation" #salutations="ngModel"
                            [class.form-input-error]="(salutations?.invalid && (salutations?.dirty || salutations?.touched)) && (salutations.errors?.required)"
                            [class.form-input-success]="(!salutations?.invalid && (salutations?.dirty || salutations?.touched)) && !(salutations.errors?.required)"
                            required>
                            <option value=null disabled selected>Select your Salutation</option>
                            <option *ngFor="let salutation of this.doctorreg.others_data.salutations"
                                value={{salutation.value}}>
                                {{salutation.label}}
                            </option>
                        </select>
                        <div *ngIf="!this.doctorreg_boolean.salutation" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Salutation is required.
                            </div>
                        </div>
                        <div *ngIf="salutations?.invalid && (salutations?.dirty || salutations?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.salutation && salutations.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Salutation is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold ml-1" for="primarys">Primary Speciality*</label>
                        <select name="primarys" class="custom-select custom-select mb-3 rounded-pill"
                            [(ngModel)]="this.doctorreg.api_data.primary_speciality_id" #primary_specialty="ngModel"
                            [class.form-input-error]="(primary_specialty?.invalid && (primary_specialty?.dirty || primary_specialty?.touched)) && (primary_specialty.errors?.required)"
                            [class.form-input-success]="(!primary_specialty?.invalid && (primary_specialty?.dirty || primary_specialty?.touched)) && !(primary_specialty.errors?.required)"
                            required>
                            <option value=null disabled selected>Choose your Primary Speciality</option>
                            <option *ngFor="let specialty of this.doctorreg.others_data.primary_specialties"
                                [ngValue]="specialty.value">
                                {{specialty.label}}
                            </option>
                        </select>
                        <div *ngIf="!this.doctorreg_boolean.primary_speciality_id" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Primary Speciality is required.
                            </div>
                        </div>
                        <div *ngIf="primary_specialty?.invalid && (primary_specialty?.dirty || primary_specialty?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.primary_speciality_id && primary_specialty.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Primary Speciality is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="font-weight-bold ml-3" for="degree">Medical Degree*</label>
                        <input type="text" class="form-control rounded-pill" id="degree" name="degree"
                            aria-describedby="degree" [pattern]="this.blockSpecialCharachters"
                            placeholder="Enter Medical Degree" [(ngModel)]="this.doctorreg.api_data.degree"
                            #medical_degree="ngModel"
                            [class.form-input-error]="(medical_degree?.invalid && (medical_degree?.dirty || medical_degree?.touched)) && (medical_degree.errors?.required)"
                            [class.form-input-success]="(!medical_degree?.invalid && (medical_degree?.dirty || medical_degree?.touched)) && !(medical_degree.errors?.required)"
                            required>
                        <p class="ml-2">(Ex:MD,DM,MS.)</p>
                        <div *ngIf="!this.doctorreg_boolean.degree" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Medical Degree is required.
                            </div>
                        </div>
                        <div *ngIf="medical_degree?.invalid && (medical_degree?.dirty || medical_degree?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.degree && medical_degree.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Medical Degree is required.
                            </div>
                            <div *ngIf="medical_degree.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Special charchters such as ,&lt;,&gt;,*,! are not allowed.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="font-weight-bold ml-3" for="gmc_reg_no">GMC Registration Number<span
                                *ngIf="isUK()">*</span></label>
                        <input type="text" class="form-control rounded-pill" id="gmc_reg_no" name="gmc_reg_no"
                            aria-describedby="gmc_reg_no" [pattern]="this.blockSpecialCharachters"
                            placeholder="Enter GMC Registration Number" [(ngModel)]="this.doctorreg.api_data.gmc_reg_no"
                            #gmc_reg_number="ngModel"
                            [class.form-input-error]="(gmc_reg_number?.invalid && (gmc_reg_number?.dirty || gmc_reg_number?.touched)) && (gmc_reg_number.errors?.required)"
                            [class.form-input-success]="(!gmc_reg_number?.invalid && (gmc_reg_number?.dirty || gmc_reg_number?.touched)) && !(gmc_reg_number.errors?.required)"
                            [required]="isUK()">
                        <div *ngIf="!this.doctorreg_boolean.degree" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                GMC Registration Number is required.
                            </div>
                        </div>
                        <div *ngIf="gmc_reg_number?.invalid && (gmc_reg_number?.dirty || gmc_reg_number?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.degree && gmc_reg_number.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                GMC Registration Number is required.
                            </div>
                            <div *ngIf="gmc_reg_number.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Special charchters such as ,&lt;,&gt;,*,! are not allowed.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="font-weight-bold ml-3" for="passing_year">Passing Year<span
                                *ngIf="isUK()">*</span></label>
                        <input type="text" class="form-control rounded-pill" id="passing_year" name="passing_year"
                            aria-describedby="passing_year" [pattern]="this.blockSpecialCharachters"
                            placeholder="Enter Passing Year" [(ngModel)]="this.doctorreg.api_data.passing_year"
                            #passing_year="ngModel"
                            [class.form-input-error]="(passing_year?.invalid && (passing_year?.dirty || passing_year?.touched)) && (passing_year.errors?.required)"
                            [class.form-input-success]="(!passing_year?.invalid && (passing_year?.dirty || passing_year?.touched)) && !(passing_year.errors?.required)"
                            [required]="isUK()">
                        <div *ngIf="!this.doctorreg_boolean.degree" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Passing Year is required.
                            </div>
                        </div>
                        <div *ngIf="passing_year?.invalid && (passing_year?.dirty || passing_year?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.degree && passing_year.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Passing Year is required.
                            </div>
                            <div *ngIf="passing_year.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Special charchters such as ,&lt;,&gt;,*,! are not allowed.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold" for="medicalschool">Medical School*</label>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <app-table-data *ngIf="this.doctorreg.table_data.MedicalSchool.refresh"
                            [data]="this.doctorreg.others.MedicalSchool"
                            [columns]="this.doctorreg.table_data.MedicalSchool.columns"
                            (onUpdate)="this.update('MedicalSchool',$event)"></app-table-data>

                        <div *ngIf="!this.doctorreg_boolean.medical_school" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Medical School is required.
                            </div>
                        </div>
                    </div>
                </div>



                <div class="form-group row" *ngIf="!this.getIsNationalLicense()">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold" for="statestopractice">States to Practice*</label>
                    </div>
                </div>
                <div class="form-group row" *ngIf="!this.getIsNationalLicense()">
                    <div class="col-sm-12 col-md-12">
                        <app-table-data *ngIf="this.doctorreg.table_data.StatesToPractice.refresh"
                            [data]="this.doctorreg.others.StatesToPractice"
                            [columns]="this.doctorreg.table_data.StatesToPractice.columns"
                            (onUpdate)="this.update('StatesToPractice',$event)"></app-table-data>

                        <div *ngIf="!this.doctorreg_boolean.medical_school" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                States to Practice is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row" *ngIf="this.getIsNationalLicense()">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold" for="licensenumber">License Number*</label>
                        <input type="text" class="form-control rounded-pill" id="licensenumber" name="licensenumber"
                            aria-describedby="licensenumber" placeholder="Enter License Number"
                            [(ngModel)]="this.doctorreg.others.national_license_number" #license_no="ngModel"
                            [class.form-input-error]="(license_no?.invalid && (license_no?.dirty || license_no?.touched)) && (license_no.errors?.required)"
                            [class.form-input-success]="(!license_no?.invalid && (license_no?.dirty || license_no?.touched)) && !(license_no.errors?.required)"
                            required>

                        <div *ngIf="!this.doctorreg_boolean.states_to_practice" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                License Number is required.
                            </div>
                        </div>
                        <div *ngIf="license_no?.invalid && (license_no?.dirty || license_no?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.states_to_practice && license_no.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                License Number is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-md-8 col-sm-12">
                        <label class="col-sm-12 font-weight-bold">Profile Photo*</label>
                        <p-fieldset styleClass="sample-photo-fieldset" id="samplephoto">
                            <p-header>
                                Sample Profile Photo
                            </p-header>
                            <img src="./assets/images/samplePhotos/doc001.jpg" alt="Sample Photo"
                                class="sample-photo-doctor-registration">
                            <img src="./assets/images/samplePhotos/doc002.jpg" alt="Sample Photo"
                                class="sample-photo-doctor-registration">
                            <div class="ui-g-12" style="text-align: center;font-weight: bold;">
                                Recommended Image Dimensions
                                <p>800 pixels X 850 pixels</p>
                            </div>
                        </p-fieldset>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <p-fileUpload name="photo" id="photo" chooseLabel="Choose" [showCancelButton]="false"
                            styleClass="p-fileUpload-label-fix" [showUploadButton]="false" [maxFileSize]="5033165"
                            accept="image/*" (onSelect)="fileSave(fileType.photo,$event.files[0])"
                            (onClear)="this.doctorreg.api_data.avatar=null"
                            (onRemove)="this.doctorreg.api_data.avatar=null">
                        </p-fileUpload>
                        <p class="text-center">
                            <span class="font-weight-bold">Note</span>: The
                            file type supported for Profile Photo are JPEG,JPG,PNG.
                        </p>
                    </div>
                    <div *ngIf="!this.doctorreg_boolean.profile_photo" class="col-sm-12">
                        <div class="col-sm-12 alert alert-danger m-2" role="alert">
                            Profile Photo is required.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold">Resume</label>
                        <p-fileUpload name="resume" id="resume" chooseLabel="Choose(Optional)"
                            [showCancelButton]="false" styleClass="p-fileUpload-label-fix" [showUploadButton]="false"
                            [maxFileSize]="5033165" accept=".pdf" (onSelect)="fileSave(fileType.resume,$event.files[0])"
                            (onClear)="this.doctorreg.api_data.resume=null"
                            (onRemove)="this.doctorreg.api_data.resume=null">
                            <p class="text-center text-gray-underline"><span class="font-weight-bold">Note</span>: The
                                file type supported for Resume/CV is PDF.</p>
                        </p-fileUpload>
                    </div>
                </div>
                <!-- Upload Section -->
                <div class="form-group-row" *ngIf="this.is_uk_country">
                    <label class="col-sm-12 font-weight-bold mb-3">Certificates*</label>

                    <div *ngFor="let doc of Document_data" class="p-mb-3">
                        <div class="col-12">
                            <label class="p-d-block p-mb-1 font-weight-medium">{{ doc.name }}*</label>
                            <p-fileUpload [showCancelButton]="false" [showUploadButton]="false"
                                styleClass="p-fileUpload-label-fix" accept=".pdf,.jpg,.jpeg,.png"
                                chooseLabel="Choose File" (onSelect)="onFileSelected($event, doc.id)"
                                (onClear)="onFileRemoved(doc.id)" (onRemove)="onFileRemoved(doc.id)">
                            </p-fileUpload>

                        </div>
                    </div>
                    <div style="margin-top:20px;">
                        <p-table [value]="filteredDocuments()" *ngIf="filteredDocuments().length"
                            [styleClass]="'p-datatable-gridlines p-datatable-sm p-mt-4'">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 30%; word-wrap: break-word;">Certificate</th>
                                    <th style="width: 40%; word-wrap: break-word;">File Name</th>
                                    <th style="width: 30%;">Expiry Date</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr *ngFor="let cert of row.data">
                                    <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ row.name }}</td>
                                    <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ cert.file.name }}</td>
                                    <td>{{ cert.expiryDate }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <!-- Styled Table -->

                </div>

                <!-- Enhanced Upload Dialog -->
                <p-dialog header="Upload Certificate" [(visible)]="displayUploadDialog" [modal]="true"
                    [closable]="false" [style]="{width: '400px'}" contentStyleClass="p-px-3 p-pt-2 p-pb-0">
                    <div class="p-fluid p-mb-2">
                        <div class="p-field p-mb-3">
                            <label class="p-d-block font-medium mb-2">Selected File</label>
                            <div class="p-inputtext p-disabled p-component" style="padding: 0.5rem;">
                                {{ uploadForm.file?.name || 'No file selected' }}
                            </div>
                        </div>

                        <div class="p-field p-mb-3">
                            <label for="expiryDate" class="p-d-block font-medium mb-2">Expiry Date</label>
                            <p-calendar [(ngModel)]="uploadForm.expiryDate" inputId="expiryDate" dateFormat="yy-mm-dd"
                                [minDate]="minDate" showIcon="true" class="w-full" appendTo="body"
                                placeholder="Select expiry date"></p-calendar>
                        </div>
                    </div>

                    <p-footer class="p-d-flex p-jc-end p-mt-3">
                        <button pButton type="button" label="Cancel" class="p-button-secondary p-mr-2"
                            (click)="cancelUpload()"></button>
                        <button pButton type="button" label="Upload" class="p-button-primary"
                            (click)="confirmUpload()"></button>
                    </p-footer>
                </p-dialog>






                <div class="form-group row">
                    <label class="col-sm-12 font-weight-bold" for="pin">Set your 4 digit pin*</label>
                    <div class="input-group">
                        <input [type]="!this.doctorreg.others.pinData.isPassword?'text':'password'"
                            class="form-control input-of-append-icon" id="pin" name="pin" aria-describedby="pin"
                            maxlength="4" minlength="4" [pattern]="phoneNumber"
                            [(ngModel)]="this.doctorreg.api_data.pin" #pin="ngModel"
                            [class.form-input-error]="(pin?.invalid && (pin?.dirty || pin?.touched)) && (pin.errors?.required || pin.errors?.minlength || pin.errors?.maxlength)"
                            [class.form-input-success]="(!pin?.invalid && (pin?.dirty || pin?.touched)) && !(pin.errors?.required || pin.errors?.minlength || pin.errors?.maxlength)"
                            required>
                        <div class="input-group-append">
                            <span class="input-group-text icon-of-append-icon"
                                [class.form-input-error]="(pin?.invalid && (pin?.dirty || pin?.touched)) && (pin.errors?.required || pin.errors?.minlength || pin.errors?.maxlength )"
                                [class.form-input-success]="(!pin?.invalid && (pin?.dirty || pin?.touched)) && !(pin.errors?.required || pin.errors?.minlength || pin.errors?.maxlength)">
                                <i toggle="#pin-field" role="button" class="text-dark fa fa-fw"
                                    [ngClass]="{'fa-eye': this.doctorreg.others.pinData.isPassword,'fa-eye-slash': !this.doctorreg.others.pinData.isPassword}"
                                    (click)="this.doctorreg.others.pinData.toggleType()">
                                </i>
                            </span>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.pin" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Pin is required.
                            </div>
                        </div>
                        <div *ngIf="pin?.invalid && (pin?.dirty || pin?.touched)" class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.pin && pin.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Pin is required.
                            </div>
                            <div *ngIf="pin.errors?.minlength" class="col-sm-12 alert alert-danger m-2" role="alert">
                                Pin should be of 4 digits.
                            </div>
                            <div *ngIf="pin.errors?.maxlength" class="col-sm-12 alert alert-danger m-2" role="alert">
                                Pin should be of 4 digits.
                            </div>
                            <div *ngIf="pin.errors?.pattern" class="col-sm-12 alert alert-danger m-2" role="alert">
                                Only Numbers are allowed.
                            </div>

                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold" for="Description">Description</label>
                        <textarea id="Description" class="WordWrap format-lines textarea-doctor-registration"
                            placeholder="Describe yourself(Optional)" name="Description"
                            [(ngModel)]="this.doctorreg.api_data.description">
                    </textarea>

                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12 col-md-12">
                        <label class="col-sm-12 font-weight-bold ml-1" for="user_source">How did you come to know about
                            us?*</label>
                        <select name="user_source" class="custom-select custom-select mb-3 rounded-pill"
                            [(ngModel)]="this.doctorreg.api_data.user_source_id" #user_source="ngModel"
                            [class.form-input-error]="(user_source?.invalid && (user_source?.dirty || user_source?.touched)) && (user_source.errors?.required)"
                            [class.form-input-success]="(!user_source?.invalid && (user_source?.dirty || user_source?.touched)) && !(user_source.errors?.required)"
                            required
                            (ngModelChange)="doctorreg_boolean.other_source=(doctorreg.api_data.user_source_id==12)">
                            <option [value]='null' disabled selected>Select your source</option>
                            <option *ngFor="let source of this.doctorreg.others.user_source" value={{source.value}}>
                                {{source.label}}
                            </option>
                        </select>
                        <div *ngIf="!doctorreg_boolean.user_source_id" class="col-sm-12 alert alert-danger m-2"
                            role="alert">
                            User source is required.
                        </div>
                        <div *ngIf="user_source?.invalid && (user_source?.dirty || user_source?.touched)"
                            class="col-sm-12">
                            <div *ngIf="doctorreg_boolean.user_source_id || user_source.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                User source is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row" *ngIf="doctorreg.api_data.user_source_id==12">
                    <div class="col-sm-12 col-md-12">
                        <input type="text" class="form-control rounded-pill" id="other_source" name="other_source"
                            aria-describedby="other_source" [pattern]="blockSpecialCharachters"
                            placeholder="Enter Other Source" [(ngModel)]="doctorreg.api_data.other_user_source"
                            #other_source="ngModel" maxlength="200"
                            [class.form-input-error]="(other_source?.invalid && (other_source?.dirty || other_source?.touched)) && (other_source.errors?.required)"
                            [class.form-input-success]="(!other_source?.invalid && (other_source?.dirty || other_source?.touched)) && !(other_source.errors?.required)"
                            required>
                        <div *ngIf="!this.doctorreg_boolean.other_source" class="col-sm-12">
                            <div class="col-sm-12 alert alert-danger m-2" role="alert">
                                Other Source is required.
                            </div>
                        </div>
                        <div *ngIf="other_source?.invalid && (other_source?.dirty || other_source?.touched)"
                            class="col-sm-12">
                            <div *ngIf="this.doctorreg_boolean.other_source && other_source.errors?.required"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Other Source is required.
                            </div>
                            <div *ngIf="other_source.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Special charchters such as ,&lt;,&gt;,*,! are not allowed.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="form-group row">
            <div class="form-group form-check ml-5 mt-4">
                <input type="checkbox" class="form-check-input register-checkbox-fix" id="terms" name="terms"
                    [(ngModel)]="this.doctorreg.others.agree">
                <label class="col-sm-12 font-weight-bold" class="form-check-label" for="customCheck1">
                    I agree to the <a [href]="this.terms_and_conditions_url" target="_blank">Terms
                        &amp;
                        Conditions</a>
                </label>
                <div *ngIf="!this.doctorreg_boolean.agree" class="col-sm-12">
                    <div class="col-sm-12 alert alert-danger m-2" role="alert">
                        Agree is required.
                    </div>
                </div>
            </div>
        </div> -->

            <div class="form-group row justify-content-center">
                <div class="m-3">
                    <div id="recaptcha-div2">
                        <re-captcha *ngIf="this.doctorreg.others.recaptchaData.recaptcha_Reset"
                            class="recaptcha ng-valid" name="recaptcha" matInput style="display: inline-block;"
                            (resolved)="resolved($event)" [(ngModel)]="this.doctorreg.api_data.recaptcha"
                            #recaptcha="ngModel" [siteKey]="sitekey" required>
                        </re-captcha>
                    </div>
                </div>
            </div>
            <div *ngIf="!this.doctorreg_boolean.recaptcha" class="col-sm-12">
                <div class="col-sm-12 alert alert-danger m-2" role="alert">
                    Recaptcha is required.
                </div>
            </div>
            <div class="row">
                <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                </app-loading>
            </div>
            <div class="form-group row">
                <div class="col-sm-12 col-md-12">
                    <div class="my-3">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 text-center m-auto ">
                                <button type="button" (click)="this.saveLocal()" [disabled]="isPosting()"
                                    class="btn btn-default btn-primary white-theme-egd-bg-btn egd-login-signup-buttons mx-2 p-2">
                                    <span class="white-theme-egd-bg-btn-label ">
                                        Save
                                    </span>
                                </button>
                            </div>

                            <div class="col-sm-12 col-md-6 text-center m-auto pt-3 pt-md-0 pt-lg-0">
                                <button type="submit" [disabled]="isPosting() || !isCertificateSectionValid()"
                                    class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons mx-2 p-2">
                                    <span class="egd-theme-white-bg-btn-label ">
                                        Register
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="alert alert-warning text-dark" role="alert">
                        Note:
                        <ul>
                            <li>
                                Save button will only save textual data and not the pin,password and media files.
                            </li>
                            <li>
                                Use Same Browser to continue the registration.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div *ngIf="this.doctorreg.others.fetchDataDialog.show">
                <app-confirm-dialog (confirmAction)="this.fetchDataDialogAction($event)"
                    [data]="this.doctorreg.others.fetchDataDialog.data">
                </app-confirm-dialog>
            </div>

            <div *ngIf="this.doctorreg.others.successDialog.show">
                <app-confirm-dialog (confirmAction)="this.successDataDialogAction($event)"
                    [data]="this.doctorreg.others.successDialog.data">
                </app-confirm-dialog>
            </div>
        </form>
        <div class="row">
            <div class="col-sm-12 mx-4 mx-md-0 mx-lg-0">
                <p>Already have an account ? <a
                        [routerLink]="['/', this.slug, 'user', 'login', 'health-care-professionals', 'doctor']"> Sign
                        in</a>
                </p>
            </div>
        </div>

        <p class="heading4"><b>Facing any issue in Registration? Reach out to us through WhatsApp.</b></p>
        <div class="col-12 text-center whatsapp-button" *ngIf="!this.is_uk_country">
            <a rel="noopener noreferrer nofollow"
                href="https://api.whatsapp.com/send?phone=16102458765&app=facebook&entry_point=page_cta&fbclid=IwAR1MEiDbyA8J42x5LpNUSweMm1NTgDy5JYfLA0DCtVgnLGVHlTPU5GF2vfg"
                target="_blank">
                <p class="heading4 chatbtn p-2 egd-theme-text font-weight-bold">CHAT SUPPORT <span><img
                            class="whatsapp-social my-auto" src="./assets/images/social_icons/whatsapp.png"
                            alt="whatsapp eGlobalDoctors"></span></p>
            </a>
        </div>
        <div class="col-12 text-center whatsapp-button" *ngIf="this.is_uk_country">
            <a rel="noopener noreferrer nofollow" href="https://wa.me/447599422048" target="_blank">
                <p class="heading4 chatbtn p-2 egd-theme-text font-weight-bold">CHAT SUPPORT <span><img
                            class="whatsapp-social my-auto" src="./assets/images/social_icons/whatsapp.png"
                            alt="whatsapp eGlobalDoctors"></span></p>
            </a>
        </div>
    </ng-container>

    <ng-container *ngIf="this.doctorreg.others.tabViewData.selected_tab==1">
        <div class="form-back  h4 my-4">
            <a [routerLink]="['/', this.slug, 'user', 'doctor', 'registration']">&#8592; Back</a>
        </div>
        <div class="form-heading-section mt-4">
            <h2>Verify Mobile</h2>
            <p class="form-sub-heading">
                We have sent an OTP on
            </p>
            <h2>{{this.doctorreg.api_data.primary_contact_number}}</h2>
        </div>
        <div class="form-div">
            <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
                <div class="form-group row">
                    <otp-input class="col-12" [isPrimeNg]="false" [otp_data]="this.doctorreg.others.otp_data"
                        (otp_resend)="otp_resend()">
                    </otp-input>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="form-submit-button  my-3">
                            <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                                [disabled]="isPosting() || !otpForm.valid">
                                Verify
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>

    <div class="mt-3 mx-2">
        <div class="row">
            <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
            </app-loading>
        </div>
        <!-- <div class="text-center">
                <div class="spinner-border text-primary" role="status" *ngIf="this.formPosting==true">
                    <span class="sr-only">Loading...</span>
                </div>
            </div> -->

        <div
            *ngIf="this.doctorreg.others.form_error_message_result.PromiseResult?.success!=null && this.doctorreg.others.form_error_message_result.PromiseResult?.success==false && this.doctorreg.others.form_error_message_result.PromiseResult?.data!=null && this.doctorreg.others.form_error_message_result.PromiseResult?.data.length>0">
            <p>Following fields are not filled:</p>
            <div *ngFor="let message of this.doctorreg.others.form_error_message_result.PromiseResult.data ;let i = index"
                class="alert alert-danger">
                {{(i+1) +". "+ message}}
            </div>
        </div>

        <app-error-messages [api_result]=" this.doctorreg.others.formData_apiResult"></app-error-messages>

        <app-error-messages [api_result]=" this.doctorreg.others.otp_data.otp_api_result"></app-error-messages>
    </div>

    <div class="footer-copyright-section mt-0">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>
</div>